/* sk8 Monster Drops: leva a sacola da loja para o checkout próprio.

   O botão "Finalizar compra" da sacola (templates/cart.liquid, name="checkout")
   abre o checkout próprio com os itens, o cupom aplicado na loja e o token do
   carrinho. Adaptado do checkout da Traction em 26/09/2026.

   Enquanto o checkout próprio estiver fechado (CHECKOUT_ABERTO diferente de
   "sim" no Worker sk8-checkout), ele mesmo devolve a pessoa ao checkout da
   Shopify com a mesma sacola e o mesmo cupom. Sem window.SK8_CHECKOUT.checkoutUrl,
   o botão segue para a Shopify como sempre.

   Fonte em tema/tema-shopify/assets/. Editar aqui, não no painel da Shopify. */
(function () {
  "use strict";

  var C = window.SK8_CHECKOUT || {};
  if (!C.checkoutUrl) return;

  var SELETOR = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';
  var indo = false;
  /* voltar do checkout pelo botão do navegador devolve a página da memória (Safari do
     iPhone) com indo ainda true, e os botões de pagar paravam de responder */
  window.addEventListener("pageshow", function (e) { if (e.persisted) indo = false; });

  function cupomDoCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function irParaCheckout(alvo) {
    if (indo) return;
    indo = true;
    if (alvo && alvo.setAttribute) alvo.setAttribute("aria-busy", "true");
    var liberar = function () {
      indo = false;
      if (alvo && alvo.removeAttribute) alvo.removeAttribute("aria-busy");
    };

    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("cart " + r.status);
        return r.json();
      })
      .then(function (cart) {
        var itens = (cart.items || [])
          .map(function (i) { return i.variant_id + ":" + i.quantity; })
          .join(",");
        if (!itens) { liberar(); return; }

        var u = new URL(C.checkoutUrl);
        u.searchParams.set("items", itens);
        // Todos os cupons do carrinho, mesmo os que a loja ainda não aplicou: o checkout
        // pergunta à Shopify com o e-mail e o frete, e alguns só valem a partir daí
        // (cupom de segmento, frete grátis). Desde 09/10/2026 ele aceita vários.
        var cupons = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        var doCookie = cupomDoCookie();
        if (doCookie && cupons.indexOf(doCookie) === -1) cupons.push(doCookie);
        if (cupons.length) u.searchParams.set("cupom", cupons.join(","));
        if (cart.token) u.searchParams.set("cart_token", cart.token);
        if (C.email) u.searchParams.set("email", C.email);
        location.href = u.toString();
      })
      .catch(function () {
        // Ler o carrinho falhou. A venda não pode se perder por isso: segue
        // para o checkout da Shopify, como seria sem este script.
        liberar();
        location.href = "/checkout";
      });
  }

  document.addEventListener(
    "click",
    function (e) {
      var alvo = e.target && e.target.closest ? e.target.closest(SELETOR) : null;
      if (!alvo) return;
      e.preventDefault();
      e.stopPropagation();
      irParaCheckout(alvo);
    },
    true,
  );

  // O formulário da sacola é envio nativo: Enter num campo dispara o submit
  // sem clique. Este ouvinte cobre esse caminho.
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      var enviador = e.submitter;
      if (enviador && enviador.name !== "checkout") return;
      e.preventDefault();
      e.stopPropagation();
      irParaCheckout(enviador);
    },
    true,
  );
})();
